/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowSharpTurnLeft = createReactComponent("outline", "arrow-sharp-turn-left", "IconArrowSharpTurnLeft", [["path", { "d": "M17 18v-11.31a.7 .7 0 0 0 -1.195 -.495l-9.805 9.805", "key": "svg-0" }], ["path", { "d": "M11 16h-5v-5", "key": "svg-1" }]]);

export { IconArrowSharpTurnLeft as default };
//# sourceMappingURL=IconArrowSharpTurnLeft.mjs.map
